export function sortNumbers(a: string, b: string) {
  return a > b ? 1 : -1;
}
